/**
 * @generated SignedSource<<2f77db61341421d1914f9b10c6967fbe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutPayPalWrapper_buyer$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"useCheckoutIsLoggedIntoPayPal_buyer" | "usePayPalPaymentMethod_buyer">;
  readonly " $fragmentType": "CheckoutPayPalWrapper_buyer";
};
export type CheckoutPayPalWrapper_buyer$key = {
  readonly " $data"?: CheckoutPayPalWrapper_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutPayPalWrapper_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutPayPalWrapper_buyer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCheckoutIsLoggedIntoPayPal_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePayPalPaymentMethod_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "87188478a44af0472847cec0760d401b";

export default node;
